var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import withBranding from "@irati/brand/withBranding";
import UpdateBrand from "@irati-web/admin/src/components/Settings/Brand";
import BrandPreview, { PreviewVariants } from "./BrandPreview";
var SetBrand = /** @class */ (function (_super) {
    __extends(SetBrand, _super);
    function SetBrand() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            settingBrand: false
        };
        _this.componentDidMount = function () { return _this.props.isDefaultBrand().then(function (showUpload) { return _this.setState({ showUpload: showUpload }); }); };
        _this.startSetBrand = function () {
            _this.setState({ settingBrand: true });
        };
        _this.onBrandUpdated = function () {
            _this.props.setIsStepCompletable(true);
            _this.setState({ settingBrand: false, showUpload: false });
        };
        _this.onColorUpdate = function (color) { return _this.setState({ forceColor: color }); };
        return _this;
    }
    SetBrand.prototype.render = function () {
        var _a = this.state, settingBrand = _a.settingBrand, showUpload = _a.showUpload, forceColor = _a.forceColor;
        var branding = this.props.branding;
        var businessLogoUrl = branding.businessLogoUrl;
        var variant = showUpload ? PreviewVariants.Unset : PreviewVariants.Custom;
        if (!settingBrand) {
            return React.createElement(BrandPreview, { forceColor: forceColor, variant: variant, handleClick: this.startSetBrand });
        }
        return (React.createElement(UpdateBrand, { imageLink: businessLogoUrl, showUpload: showUpload, onColorUpdate: this.onColorUpdate, onBrandUpdated: this.onBrandUpdated }));
    };
    return SetBrand;
}(PureComponent));
export default withBranding(SetBrand);
